import { render, staticRenderFns } from "./PdText.vue?vue&type=template&id=a8871d22&"
import script from "./PdText.vue?vue&type=script&lang=js&"
export * from "./PdText.vue?vue&type=script&lang=js&"
import style0 from "./PdText.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports